module.exports = __webpack_public_path__ + "static/media/iceberg.61bcbef4.svg";